"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ViewerChooser_1 = require("./ResultHeader/ViewerChooser");
var cx = require("classnames");
var ResultHeader = function ResultHeader(_a) {
  var selectedViewer = _a.selectedViewer,
      onChangeViewer = _a.onChangeViewer,
      showViewAs = _a.showViewAs,
      showResponseTitle = _a.showResponseTitle,
      showSelectUser = _a.showSelectUser;
  return React.createElement(
    "div",
    { className: cx('result-header subscription'), "data-jsx": 3076978164
    },
    React.createElement(_style2.default, {
      styleId: 3076978164,
      css: ".result-header[data-jsx=\"3076978164\"] {height: 75px}.result-header[data-jsx=\"3076978164\"].subscription[data-jsx=\"3076978164\"] {}.result-header[data-jsx=\"3076978164\"].subscription[data-jsx=\"3076978164\"][data-jsx=\"3076978164\"]:after {content: \"\";position: absolute;bottom: -25px;left: 0;right: 0;height: 25px;background: -webkit-linear-gradient(top, rgba(23, 42, 58, 1) 0%,rgba(23, 42, 58, 0) 100%);background: linear-gradient(to bottom, rgba(23, 42, 58, 1) 0%,rgba(23, 42, 58, 0) 100%);z-index: 4}.bgDarkBlue,\n.result-header[data-jsx=\"3076978164\"] {background-color: #172a3a}.flex,\n.result-header[data-jsx=\"3076978164\"] {display: -ms-flexbox;display: flex}.justifyBetween,\n.result-header[data-jsx=\"3076978164\"] {-ms-flex-pack: justify;justify-content: space-between}.itemsCenter,\n.result-header[data-jsx=\"3076978164\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center}.relative,\n.result-header[data-jsx=\"3076978164\"] {position: relative}.pt25,\n.result-header[data-jsx=\"3076978164\"] {padding-top: 25px}.mh25,\n.result-header[data-jsx=\"3076978164\"] {margin-left: 25px;margin-right: 25px}.pl16,\n.result-header[data-jsx=\"3076978164\"] {padding-left: 16px}.absolute,\n.inner[data-jsx=\"3076978164\"] {position: absolute}"
    }),
    React.createElement(
      "div",
      { className: "inner", "data-jsx": 3076978164
      },
      React.createElement(
        "div",
        {
          "data-jsx": 3076978164
        },
        showResponseTitle && React.createElement(
          "div",
          { className: "editor-title", "data-jsx": 3076978164
          },
          "Response"
        )
      ),
      showViewAs && selectedViewer && onChangeViewer && React.createElement(ViewerChooser_1.default, { showSelectUser: showSelectUser, selectedViewer: selectedViewer, onChangeViewer: onChangeViewer })
    )
  );
};
exports.default = ResultHeader;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/ResultHeader.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/ResultHeader.js
// module chunks = 0